import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import Reveal from './Reveal';

const titleSizes = {
  sm: { base: 'xl', md: '2xl' },
  md: { base: '2xl', md: '3xl' },
  lg: { base: '2xl', sm: '3xl', md: '4xl' },
  xl: { base: '3xl', md: '4xl' },
  '2xl': { base: '2xl', sm: '3xl', md: '4xl' },
};

const SectionHeading = ({
  eyebrow,
  title,
  lead,
  align = 'center',
  accent = 'brand.500',
  titleColor = 'gray.900',
  leadColor = 'gray.600',
  maxW = '3xl',
  size = '2xl',
  mb = 14,
  ...props
}) => (
  <Reveal>
    <VStack
      spacing={4}
      align={align === 'center' ? 'center' : 'flex-start'}
      textAlign={align}
      maxW={maxW}
      mx={align === 'center' ? 'auto' : 0}
      mb={mb}
      {...props}
    >
      {eyebrow && (
        <Box
          display="inline-flex"
          alignItems="center"
          gap={3}
          color={accent}
          fontWeight="700"
          textTransform="uppercase"
          letterSpacing="0.14em"
          fontSize="xs"
        >
          <Box w="28px" h="2px" bg={accent} borderRadius="full" />
          {eyebrow}
        </Box>
      )}

      <Heading
        as="h2"
        fontSize={titleSizes[size] || titleSizes['2xl']}
        color={titleColor}
        fontWeight="800"
        lineHeight="1.15"
      >
        {title}
      </Heading>

      {lead && (
        <Text fontSize={{ base: 'md', md: 'lg' }} color={leadColor} lineHeight="1.8" maxW="2xl">
          {lead}
        </Text>
      )}
    </VStack>
  </Reveal>
);

export default SectionHeading;
